import Queue from "nq";

class AuditLogUseCase {
  constructor() {
    this.document = new Queue.Document();
  }

  create({
    user,
    logDate,
    message,
    collection,
    objectId,
    payload = {},
    store,
  }) {
    return this.log(
      "create",
      user,
      logDate,
      message,
      collection,
      objectId,
      payload,
      store
    );
  }

  update({
    user,
    logDate,
    message,
    collection,
    objectId,
    payload = {},
    store,
  }) {
    return this.log(
      "update",
      user,
      logDate,
      message,
      collection,
      objectId,
      payload,
      store
    );
  }

  delete({
    user,
    logDate,
    message,
    collection,
    objectId,
    payload = {},
    store,
  }) {
    return this.log(
      "delete",
      user,
      logDate,
      message,
      collection,
      objectId,
      payload,
      store
    );
  }

  log(activity, user, logDate, message, collection, objectId, payload, store) {
    const auditEntry = {
      activity,
      user: {
        id: user?.id,
      },
      logDate,
      message,
      collection,
      objectId,
      payload,
      store,
    };

    return this.document.create("audit_logs", auditEntry);
  }
}

export default AuditLogUseCase;
